import {isNotNil} from 'ramda';
import {isString} from 'ramda-adjunct';

export const formatExternalFiltersDate = (date: Date | string | null | undefined) => {
  if (isNotNil(date)) {
    if (isString(date)) {
      return date;
    }
    // eslint-disable-next-line eag/no-native-date-math -- Pre-existing native Date math, migrate to date-fns when possible
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
      date.getDate()
    ).padStart(2, '0')}`;
  }
  return null;
};
